import React, { useEffect, useState } from 'react';

import { Box, makeStyles, Typography } from '@material-ui/core';
import NextImage from 'next/image';
import { FormattedMessage } from 'react-intl';

import blurBase64 from 'constants/blurBase64';

import HorizontalList from 'components/@common/HorizontalList';

export interface GameImagesProps {
  items: { alt: string; src: string }[];
}
const useStyles = makeStyles({
  image: {
    borderRadius: 4,
  },
});

const GameImages = ({ items }: GameImagesProps) => {
  const classes = useStyles();
  const [imageDimension, setImageDimension] = useState<{ width: number; height: number }>();
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (items.length) {
      const firstImg = items[0];
      const img = new Image();
      img.src = firstImg.src;

      timeout = setTimeout(() => {
        setImageDimension({ width: 240, height: 427 });
      }, 2000);

      img.onload = () => {
        clearTimeout(timeout);
        if (img.width > img.height) {
          setImageDimension({
            width: 427,
            height: 240,
          });
        } else {
          setImageDimension({ width: 240, height: 427 });
        }
      };
      img.onerror = () => {
        setImageDimension({ width: 240, height: 427 });
      };
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [items]);

  return (
    <Box display="flex" flexDirection="column" pt={2}>
      <Typography variant="overline" color="textPrimary">
        <FormattedMessage id="game.details.about.examples" />
      </Typography>
      <Box width="100%">
        {imageDimension && (
          <HorizontalList id="game examples" omitPadding>
            {items.map(item => (
              <Box
                key={item.alt}
                width={imageDimension.width}
                borderRadius={4}
                height={imageDimension.height}
                position="relative"
                mr={2}
              >
                <NextImage
                  className={classes.image}
                  key={item.alt}
                  src={item.src}
                  alt={item.alt}
                  layout="fill"
                  objectFit="cover"
                  blurDataURL={blurBase64}
                  placeholder="blur"
                />
              </Box>
            ))}
          </HorizontalList>
        )}
      </Box>
    </Box>
  );
};

export default GameImages;
